import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const SMSPriceListBreadcrumb = ({ title, bredcrumbFlag, bredcrumbItems }) => {
  return (
    <div className="sharedBreadcrumb">
      <div
        className="breadcrumb-section breadcrumb-section-overide pl-2 pr-2"
        style={{ padding: bredcrumbFlag ? '12px 0' : '30px 0' }}
      >
        <div className="container">
          <div className="d-flex justify-content-between">
            <div>
              <div className="page-title">
                <h2>{title}</h2>
              </div>
            </div>
            {bredcrumbFlag && (
              <div>
                <nav aria-label="breadcrumb" className="theme-breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">{bredcrumbItems.item1}</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {bredcrumbItems.item2}
                    </li>
                  </ol>
                </nav>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

SMSPriceListBreadcrumb.propTypes = {
  title: PropTypes.string.isRequired,
  bredcrumbFlag: PropTypes.bool.isRequired,
  bredcrumbItems: PropTypes.object,
};

export default SMSPriceListBreadcrumb;
